import { ReportType } from '../types';

export namespace SystemUsersReportsMapper {
  export function toFront(data: ReportType[]) {
    return data.map((report) => {
      return { ...report, sum: report.sum / 100 };
    });
  }
}
